// Enable mouse drag on product media slider (Desktop)
if (!customElements.get('product-slider-drag')) {
  customElements.define('product-slider-drag', class extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.product__media-list');
      
      if (!this.slider) return;
      
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      
      this.initDrag();
    }
    
    initDrag() {
      // Mouse events
      this.slider.addEventListener('mousedown', this.onMouseDown.bind(this));
      this.slider.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.slider.addEventListener('mouseup', this.onMouseUp.bind(this));
      this.slider.addEventListener('mousemove', this.onMouseMove.bind(this));
      
      // Prevent image drag
      const images = this.slider.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });
      
      // Add grab cursor
      this.slider.style.cursor = 'grab';
    }
    
    onMouseDown(e) {
      this.isDown = true;
      this.slider.style.cursor = 'grabbing';
      this.slider.style.userSelect = 'none';
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    }
    
    onMouseLeave() {
      this.isDown = false;
      this.slider.style.cursor = 'grab';
      this.slider.style.userSelect = '';
    }
    
    onMouseUp() {
      this.isDown = false;
      this.slider.style.cursor = 'grab';
      this.slider.style.userSelect = '';
    }
    
    onMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 2; // Scroll speed multiplier
      this.slider.scrollLeft = this.scrollLeft - walk;
    }
  });
}

// Thumbnail Carousel Drag
class ThumbnailDrag {
  constructor(element) {
    this.slider = element;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.init();
  }
  
  init() {
    this.slider.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.slider.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.slider.addEventListener('mouseup', this.onMouseUp.bind(this));
    this.slider.addEventListener('mousemove', this.onMouseMove.bind(this));
    
    // Prevent default drag on images
    const images = this.slider.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }
  
  onMouseDown(e) {
    this.isDown = true;
    this.slider.style.cursor = 'grabbing';
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
  }
  
  onMouseLeave() {
    this.isDown = false;
    this.slider.style.cursor = 'grab';
  }
  
  onMouseUp() {
    this.isDown = false;
    this.slider.style.cursor = 'grab';
  }
  
  onMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.slider.scrollLeft = this.scrollLeft - walk;
  }
}

// Auto-initialize on product media wrapper
document.addEventListener('DOMContentLoaded', function() {
  // Main media slider
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  if (mediaWrapper && !mediaWrapper.hasAttribute('data-drag-init')) {
    mediaWrapper.setAttribute('data-drag-init', 'true');
    
    // Wrap in custom element
    const dragElement = document.createElement('product-slider-drag');
    const mediaList = mediaWrapper.querySelector('.product__media-list');
    if (mediaList && mediaList.parentNode) {
      const parent = mediaList.parentNode;
      parent.insertBefore(dragElement, mediaList);
      dragElement.appendChild(mediaList);
    }
  }
  
  // Thumbnail carousel drag
  const thumbnailSlider = document.querySelector('.thumbnail-slider .thumbnail-list');
  if (thumbnailSlider) {
    new ThumbnailDrag(thumbnailSlider);
  }
});
